// extracted by mini-css-extract-plugin
module.exports = {"comment":"demo-entry-module--comment--3ITSW","learnings":"demo-entry-module--learnings--2CmK8"};